export default __webpack_public_path__ + "static/media/ally_background_l1.69e104f2.jpg";